import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/sr-Cyrl/501/',
    component: ComponentCreator('/sr-Cyrl/501/', '9e0'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/',
    component: ComponentCreator('/sr-Cyrl/articles/', '94c'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'c6a'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj/', '8f3'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/archive/',
    component: ComponentCreator('/sr-Cyrl/articles/archive/', '679'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/authors/',
    component: ComponentCreator('/sr-Cyrl/articles/authors/', '5af'),
    exact: true
  },
  {
    path: '/sr-Cyrl/search/',
    component: ComponentCreator('/sr-Cyrl/search/', '490'),
    exact: true
  },
  {
    path: '/sr-Cyrl/',
    component: ComponentCreator('/sr-Cyrl/', '45e'),
    exact: true
  },
  {
    path: '/sr-Cyrl/',
    component: ComponentCreator('/sr-Cyrl/', '1eb'),
    routes: [
      {
        path: '/sr-Cyrl/',
        component: ComponentCreator('/sr-Cyrl/', '74e'),
        routes: [
          {
            path: '/sr-Cyrl/tags/',
            component: ComponentCreator('/sr-Cyrl/tags/', '791'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/comparative/',
            component: ComponentCreator('/sr-Cyrl/tags/comparative/', '48e'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/grammar/',
            component: ComponentCreator('/sr-Cyrl/tags/grammar/', '62c'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/interslavic/',
            component: ComponentCreator('/sr-Cyrl/tags/interslavic/', 'db2'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/language-learning/',
            component: ComponentCreator('/sr-Cyrl/tags/language-learning/', '845'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/linguistics/',
            component: ComponentCreator('/sr-Cyrl/tags/linguistics/', '5db'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/personal-pronouns/',
            component: ComponentCreator('/sr-Cyrl/tags/personal-pronouns/', '01f'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/pronouns/',
            component: ComponentCreator('/sr-Cyrl/tags/pronouns/', 'ff9'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/slavic-languages/',
            component: ComponentCreator('/sr-Cyrl/tags/slavic-languages/', '212'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/граматика/',
            component: ComponentCreator('/sr-Cyrl/tags/граматика/', '060'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/заменице/',
            component: ComponentCreator('/sr-Cyrl/tags/заменице/', '811'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/међусловенски-језик/',
            component: ComponentCreator('/sr-Cyrl/tags/међусловенски-језик/', 'd69'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/међусловенски/',
            component: ComponentCreator('/sr-Cyrl/tags/међусловенски/', '6bc'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/поређење-језика/',
            component: ComponentCreator('/sr-Cyrl/tags/поређење-језика/', '6a2'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/учење-језика/',
            component: ComponentCreator('/sr-Cyrl/tags/учење-језика/', '651'),
            exact: true
          },
          {
            path: '/sr-Cyrl/',
            component: ComponentCreator('/sr-Cyrl/', '09d'),
            routes: [
              {
                path: '/sr-Cyrl/learn/faq/',
                component: ComponentCreator('/sr-Cyrl/learn/faq/', '412'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/', 'eec'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/adjectives/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/adjectives/', '173'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/conjunctions/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/conjunctions/', 'a10'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/nouns/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/nouns/', 'd5d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/numerals/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/numerals/', '5e4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/prepositions/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/prepositions/', '97c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/pronouns/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/pronouns/', 'bdb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/syntax/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/syntax/', '41b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/verbs/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/verbs/', 'bb3'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/introduction/',
                component: ComponentCreator('/sr-Cyrl/learn/introduction/', 'd76'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/constructed-slavic-languages/', '2b1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/design-criteria/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/design-criteria/', '35b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/history/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/history/', '00d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/language-comparison/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/language-comparison/', '083'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/numbers-1-10/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/numbers-1-10/', '251'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/pan-slavic-relay/', '8a5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/personal-pronouns/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/personal-pronouns/', '23f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/orthography/',
                component: ComponentCreator('/sr-Cyrl/learn/orthography/', '685'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/phonology/',
                component: ComponentCreator('/sr-Cyrl/learn/phonology/', '026'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/pronunciation/',
                component: ComponentCreator('/sr-Cyrl/learn/pronunciation/', 'b8d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/simple-grammar/',
                component: ComponentCreator('/sr-Cyrl/learn/simple-grammar/', '392'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/simple-grammar/level-1/',
                component: ComponentCreator('/sr-Cyrl/learn/simple-grammar/level-1/', '4d0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/simple-grammar/level-2/',
                component: ComponentCreator('/sr-Cyrl/learn/simple-grammar/level-2/', '6e2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/vocabulary/derivation/',
                component: ComponentCreator('/sr-Cyrl/learn/vocabulary/derivation/', '6e4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/sr-Cyrl/learn/vocabulary/flavourisation/', '0bb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/vocabulary/word-formation/',
                component: ComponentCreator('/sr-Cyrl/learn/vocabulary/word-formation/', 'd5d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/resources/',
                component: ComponentCreator('/sr-Cyrl/resources/', '3ee'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/applets/',
                component: ComponentCreator('/sr-Cyrl/resources/applets/', '262'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/applets/intelligibility/',
                component: ComponentCreator('/sr-Cyrl/resources/applets/intelligibility/', '9b5'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/applets/transliterator/',
                component: ComponentCreator('/sr-Cyrl/resources/applets/transliterator/', '782'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/keyboards/',
                component: ComponentCreator('/sr-Cyrl/resources/keyboards/', '1aa'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
